import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { motion } from "framer-motion";

const AiBanner = ({ bannerdata }) => {
    const [hover, setHover] = useState(false);

    return (
        <section className="container-padding-x max-[400px]:px-[25px] relative overflow-hidden bg-[#F8FAFC]">
            <div className="flex flex-col items-center justify-center text-center pt-24 pb-20 relative z-10 max-w-6xl mx-auto">

                {/* Tag */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="bg-[#E0F2FE] text-[#0284C7] px-4 py-1 rounded-full text-sm font-semibold mb-6"
                >
                    {bannerdata.tag || "Fast. Accurate. Fully Automated."}
                </motion.div>

                {/* Title */}
                <motion.h1
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.1 }}
                    className="text-[50px] md:text-[60px] font-bold leading-tight mb-6 max-w-4xl text-[#0F172A]"
                >
                    {bannerdata.title || (
                        <>AI-Powered <span className="text-[#2563EB]">Background Verification</span> Software</>
                    )}
                </motion.h1>

                {/* Description */}
                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                    className="text-[#64748B] text-lg max-w-2xl mb-8"
                >
                    {bannerdata.description || "Hire with confidence using AI-driven background verification that eliminates manual work, reduces risk, and speeds up onboarding."}
                </motion.p>

                {/* Badges */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.3 }}
                    className="flex flex-wrapjustify-center gap-6 mb-10 text-sm font-medium text-[#334155]"
                >
                    {bannerdata.badges?.map((badge, index) => (
                        <div key={index} className="flex items-center gap-2">
                            <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path>
                            </svg>
                            <span>{badge}</span>
                        </div>
                    ))}
                </motion.div>

                {/* Buttons */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.4 }}
                    className="flex flex-col sm:flex-row gap-4"
                >
                    <Link href="/contact" className="bg-[#2563EB] hover:bg-[#1D4ED8] text-white px-8 py-3 rounded-lg font-semibold flex items-center justify-center gap-2 transition-colors">
                        Book a Demo
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                        </svg>
                    </Link>
                    <Link href="/contact" className="bg-white hover:bg-gray-50 text-[#334155] border border-gray-200 px-8 py-3 rounded-lg font-semibold transition-colors">
                        Talk to an Expert
                    </Link>
                </motion.div>

            </div>

            {/* Background Image/Effect (Optional - as per design) */}
            <div className="absolute top-0 left-0 w-full h-full pointer-events-none opacity-50 z-0">
                {/* If we have a background image similar to the design, we can use it here. 
             For now, I'll use a soft gradient or the provided image if suitable. 
         */}
                {bannerdata.img && (
                    <Image
                        src={bannerdata.img}
                        alt="Background"
                        fill
                        className="object-cover opacity-10"
                    />
                )}
            </div>

        </section>
    );
};

export default AiBanner;
